// Pobierz produkty z metapolami via GraphQL
fetch('/api/graphql.json',  {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    query: `
      query {
        products(first: 100) {
          edges {
            node {
              id
              title
              handle
              metafields(first: 10) {
                edges {
                  node {
                    key
                    value
                  }
                }
              }
            }
          }
        }
      }
    `
  })
})
.then(res => res.json())
.then(data => {
  // Przeszukaj metapoła "oe_number"
  const searchInput = document.querySelector('#search-in-modal-desktop') || document.querySelector('#search-in-modal-mobile') || document.querySelector('input[name="q"]');
  searchInput.addEventListener('input', (e) => {
    const query = e.target.value.toLowerCase();
    const results = data.data.products.edges.filter(p => {
     const oeField = p.node.metafields.edges.find(m => m.node.key === 'number_oe');
      return oeField && oeField.node.value.toLowerCase().includes(query);
    });
    console.log(results);
  });
});
